// @ts-check

import { getCountries } from '@/api/utils'
import { useLanguageStore } from '@/store/language'

export const initUtilState = () => ({
  countries: null,
  invoicingCountries: null,
  isBusinessAccountInformationDialogOpen: false
})

export const utilGetters = {
  countryOptions: (state) => {
    return state.countries ?? []
  },
  invoicingCountryOptions: (state) => {
    return state.invoicingCountries ? state.invoicingCountries : []
  },
  hasFetchedCountries: (state) => !!state.countries
}

export const utilMutations = {
  setCountries(state, countries) {
    state.countries = countries
  },
  setInvoicingCountries(state, invoicingCountries) {
    state.invoicingCountries = invoicingCountries
  },
  showBusinessAccountInformationDialog: (state) => {
    state.isBusinessAccountInformationDialogOpen = true
  },
  hideBusinessAccountInformationDialog: (state) => {
    state.isBusinessAccountInformationDialogOpen = false
  },
  clearAllData: (state) => {
    Object.assign(state, initUtilState())
  }
}

export const utilActions = {
  async fetchCountriesIfNeeded({ state, commit }, allowInvoicing = false) {
    const { language } = useLanguageStore()

    if (!state.countries && !allowInvoicing) {
      const countries = await getCountries(language)
      commit('setCountries', countries)
    }
    if (!state.invoicingCountries && allowInvoicing) {
      const invoicingCountries = await getCountries(language, allowInvoicing)
      commit('setInvoicingCountries', invoicingCountries)
    }
  }
}

export const utilModule = {
  namespaced: true,
  state: initUtilState,
  getters: utilGetters,
  actions: utilActions,
  mutations: utilMutations
}

export default utilModule
